/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：474
 */

module.exports = {
  wrapper: "SearchInput_wrapper__3Uo7M",
  header: "SearchInput_header__25Cf5",
  addButton: "SearchInput_addButton__RfNOE",
  icon: "SearchInput_icon__2Bvgv",
  addText: "SearchInput_addText__lkPZC",
  AddIcon: "SearchInput_AddIcon__1HYHW",
  disabledAddIcon: "SearchInput_disabledAddIcon__2pNPE",
  screenIcon: "SearchInput_screenIcon__1q4oI",
  iconNumber: "SearchInput_iconNumber__z0uNi",
  iconFat: "SearchInput_iconFat__2G40L",
  iconThin: "SearchInput_iconThin__n3_8c",
  iconMiddle: "SearchInput_iconMiddle__2kitu",
  tips: "SearchInput_tips__3jji_"
}
